/**
 * @module Productfavourite 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import AuthApi from '@/Components/Controllers/AuthApis';


export default {

    /**
     * Fetch order history
     */
    fetch(page) {
      const url = `${Env.orderUrl}/api/v1/orders/user/${store.getters.getLoggedInUserId}?by=id&&limit=400&sort=desc&page=${page}`;	
      return AuthApi.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Fetch order history
     */
    fetchOrderById(orderId) {
      // dont have url till now
      const url = `${Env.orderUrl}/api/v1/orders/${orderId}`;	
      return AuthApi.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => res)
      .catch(err => err);
    },

}